module.exports = (__webpack_require__(4))(0);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react/index.js from dll-reference vendorProd_library
// module id = 0
// module chunks = 42